import React from 'react'
import messages from './messages.json'

export const EventMessages = ({ show }) => show
  ? <div className='cashflow-events__message'>
    {messages.eventsList.expenseValidationMessage} <a href={messages.eventsList.learnMoreLink} target='_blank'>{messages.eventsList.learnMore}</a>
  </div>
  : null
